var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import GetLocationSamplesCommand from "../../../../commands/metrics/GetLocationSamplesCommand";
import LocationSampleCollection from "../../../../collections/metrics/LocationSampleCollection";
import Session from "../../../../services/Session";
import { Table } from "reactstrap";
import { ExportButton } from "../../../components/ui/ExportButton/ExportButton";
import { toCSV, toXLSX } from "../../../../utils/exportUtils";
import { FormattedMessage, injectIntl } from "react-intl";
import GetLocationLookupBatchCommand from "../../../../commands/location/GetLocationLookupBatchCommand";
import DateTime from "../../../components/ui/DateTime/DateTime";
var AssetLocationMetricsTable = /** @class */ (function (_super) {
    __extends(AssetLocationMetricsTable, _super);
    function AssetLocationMetricsTable(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            locationSampleCollection: new LocationSampleCollection()
        };
        return _this;
    }
    AssetLocationMetricsTable.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, interval = _a.interval, timeRange = _a.timeRange, assetModel = _a.assetModel;
        var locationSampleCollection = this.state.locationSampleCollection;
        var command = new GetLocationSamplesCommand();
        var unit = interval.toLocaleLowerCase();
        var amount = 1;
        var intervalString = amount + ' ' + unit + (amount > 1 ? 's' : '');
        command.execute(locationSampleCollection, Session.user.organisation, [assetModel.getMetricsDbId()], intervalString, timeRange).then(function () {
            var locationLookupBatchCommand = new GetLocationLookupBatchCommand();
            locationLookupBatchCommand.execute(locationSampleCollection).then(function () { return _this.forceUpdate(); });
        });
    };
    AssetLocationMetricsTable.prototype.render = function () {
        var intl = this.props.intl;
        var locationSampleCollection = this.state.locationSampleCollection;
        return React.createElement(React.Fragment, null,
            React.createElement(Table, { className: "table-sm table-responsive mt-3" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null,
                            React.createElement(FormattedMessage, { id: "metrics.DATE" })),
                        React.createElement("th", null,
                            React.createElement(FormattedMessage, { id: "metrics.FIRSTPLACE" })),
                        React.createElement("th", null,
                            React.createElement(FormattedMessage, { id: "metrics.LASTPLACE" })),
                        React.createElement("th", null,
                            React.createElement(FormattedMessage, { id: "metrics.LONGITUDE" })),
                        React.createElement("th", null,
                            React.createElement(FormattedMessage, { id: "metrics.LATITUDE" })))),
                React.createElement("tbody", null, locationSampleCollection.list.map(function (location) {
                    if (location.isCoordinate()) {
                        return React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement(DateTime, { date: new Date(location.timestamp), relativeTimeClasses: 'text-muted' })),
                            React.createElement("td", null, location.firstPlace ?
                                React.createElement("a", { href: location.getFirstPlaceGoogleMapsUrl(), target: "_blank" },
                                    React.createElement("div", { className: "d-flex justify-content-between w-100" },
                                        location.firstPlace,
                                        React.createElement("i", { className: "ml-4 fe fe-external-link" }))) : '-'),
                            React.createElement("td", null, location.lastPlace ?
                                React.createElement("a", { href: location.getLastPlaceGoogleMapsUrl(), target: "_blank" },
                                    React.createElement("div", { className: "d-flex justify-content-between w-100" },
                                        location.lastPlace,
                                        React.createElement("i", { className: "ml-4 fe fe-external-link" }))) : '-'),
                            React.createElement("td", null, location.getFirstCoordinates()[1]),
                            React.createElement("td", null, location.getFirstCoordinates()[0]));
                    }
                    else {
                        return React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement(DateTime, { date: new Date(location.timestamp), hideTime: true, compact: true })),
                            React.createElement("td", null, "-"),
                            React.createElement("td", null, "-"),
                            React.createElement("td", null, "-"),
                            React.createElement("td", null, "-"));
                    }
                }))),
            React.createElement("div", { className: "d-flex justify-content-end" },
                React.createElement(ExportButton, { onClick: function (event, type) {
                        var headersAndRows = [[
                                intl.formatMessage({ id: 'metrics.DATE' }),
                                intl.formatMessage({ id: 'metrics.LATITUDE' }),
                                intl.formatMessage({ id: 'metrics.LONGITUDE' }),
                                intl.formatMessage({ id: 'metrics.FIRSTPLACE' }),
                                intl.formatMessage({ id: 'metrics.LASTPLACE' }),
                            ]];
                        headersAndRows = headersAndRows.concat(locationSampleCollection.list.map(function (location) {
                            return [new Date(location.timestamp), location.firstPlace, location.lastPlace, location.firstLat, location.firstLong];
                        }));
                        switch (type) {
                            case 'xlsx':
                                toXLSX(headersAndRows, 'locatie');
                                break;
                            case 'csv':
                                toCSV(headersAndRows, 'locatie');
                                break;
                        }
                    } })));
    };
    AssetLocationMetricsTable = __decorate([
        observer
    ], AssetLocationMetricsTable);
    return AssetLocationMetricsTable;
}(React.Component));
export default injectIntl(AssetLocationMetricsTable);
